import { useTRPC } from "@/trpc";
import { useQuery } from "@tanstack/react-query";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { formatDate } from "@/lib/date";
import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import * as Icons from "lucide-react";
import DeleteUser from "@/components/features/users/delete-user";

const Users = () => {
  const { trpc } = useTRPC();

  const query = useQuery({
    queryKey: ["users"],
    queryFn: async () => {
      const users = await trpc.users.search.query();
      return users;
    },
  });

  return (
    <div className="h-full overflow-auto">
      <div className="flex flex-col justify-between h-full gap-4">
        <div className="flex items-center justify-between gap-4">
          <></>
        </div>
        <div className="bg-foreground/10 rounded-md border p-2 overflow-auto h-full">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Naam</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Rol</TableHead>
                <TableHead>Aangemaakt op</TableHead>
                <TableHead></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {query.data?.users?.map((user) => (
                <TableRow key={user.id}>
                  <TableCell>
                    {user.first_name} {user.last_name}
                  </TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{user.role?.name}</TableCell>
                  <TableCell>{formatDate(user.created_at)}</TableCell>
                  <TableCell>
                    <div className="flex items-center justify-end">
                      <DropdownMenu>
                        <DropdownMenuTrigger>
                          <Icons.MoreVertical className="w-4 h-4" />
                        </DropdownMenuTrigger>
                        <DropdownMenuContent>
                          <DeleteUser 
                            onDeleted={()=>{
                              query.refetch();
                            }}
                            user_id={user.id}
                            trigger={
                              <DropdownMenuItem
                                onSelect={(e) => e.preventDefault()}
                                className="text-destructive hover:!text-destructive/80"
                              >
                                <Icons.Trash className="w-4 h-4 text-destructive" />
                                Verwijderen
                              </DropdownMenuItem>
                            }
                          />
                          
                        </DropdownMenuContent>
                      </DropdownMenu>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
        <div className="flex items-center justify-between gap-4">
          <p className="text-sm font-medium text-foreground/50">
            {query?.data?.total} rijen gevonden
          </p>
          <div className="flex items-center gap-1"></div>
        </div>
      </div>
    </div>
  );
};

export default Users;
